// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * QR 스캐너 컴포넌트 스타일
 * 기본: 가로 태블릿 (landscape)
 */

.qr-scanner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: none;
  margin: 0 auto;
  gap: 24px;
}

.qr-scanner-viewport {
  position: relative;
  width: auto;
  height: 45vh;
  aspect-ratio: 1;
  background-color: #000;
  border-radius: 16px;
  overflow: hidden;
}

.qr-scanner-viewport video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qr-scanner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-scanner-frame {
  width: 70%;
  height: 70%;
  border: 3px solid #fff;
  border-radius: 12px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    border-color: rgba(255, 255, 255, 0.8);
  }
  50% {
    border-color: rgba(255, 255, 255, 0.4);
  }
}

.qr-scanner-guide {
  margin-top: 0;
  font-size: 14px;
  color: #666;
  text-align: center;
  writing-mode: horizontal-tb;
}

/* 에러 상태 */
.qr-scanner-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;
  aspect-ratio: auto;
  height: 100%;
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
}

.qr-scanner-error .error-icon {
  width: 40px;
  height: 40px;
  background-color: #ff6b6b;
  color: #fff;
  font-size: 22px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.qr-scanner-error p {
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
  line-height: 1.4;
}

.qr-scanner-error .btn-retry {
  padding: 8px 20px;
  background-color: #4a90d9;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.qr-scanner-error .btn-retry:hover {
  background-color: #3a7bc8;
}

.qr-scanner-error .btn-retry:active {
  background-color: #2d6bb5;
}

/* 개발 환경 안내 */
.qr-scanner-dev-notice {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: left;
  padding: 8px 12px;
  color: rgba(255, 255, 255, 0.8);
}

.qr-scanner-dev-notice .dev-notice-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.qr-scanner-dev-notice p {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
}

.qr-scanner-dev-notice .dev-notice-sub {
  margin-top: 2px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

/* ── 카메라 없는 기기(안드로이드 TV·프로젝터 등) 대기 화면 ───────── */
.qr-scanner-standby {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 100%;
  padding: 16px 12px;
  text-align: center;
  background: transparent;
}

.qr-scanner-standby-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #90A4AE;
}
`, "",{"version":3,"sources":["webpack://./src/components/QRScanner.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/**\n * QR 스캐너 컴포넌트 스타일\n * 기본: 가로 태블릿 (landscape)\n */\n\n.qr-scanner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: none;\n  margin: 0 auto;\n  gap: 24px;\n}\n\n.qr-scanner-viewport {\n  position: relative;\n  width: auto;\n  height: 45vh;\n  aspect-ratio: 1;\n  background-color: #000;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.qr-scanner-viewport video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.qr-scanner-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.qr-scanner-frame {\n  width: 70%;\n  height: 70%;\n  border: 3px solid #fff;\n  border-radius: 12px;\n  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    border-color: rgba(255, 255, 255, 0.8);\n  }\n  50% {\n    border-color: rgba(255, 255, 255, 0.4);\n  }\n}\n\n.qr-scanner-guide {\n  margin-top: 0;\n  font-size: 14px;\n  color: #666;\n  text-align: center;\n  writing-mode: horizontal-tb;\n}\n\n/* 에러 상태 */\n.qr-scanner-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  aspect-ratio: auto;\n  height: 100%;\n  background-color: #f5f5f5;\n  border-radius: 12px;\n  padding: 12px;\n  text-align: center;\n}\n\n.qr-scanner-error .error-icon {\n  width: 40px;\n  height: 40px;\n  background-color: #ff6b6b;\n  color: #fff;\n  font-size: 22px;\n  font-weight: bold;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.qr-scanner-error p {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n\n.qr-scanner-error .btn-retry {\n  padding: 8px 20px;\n  background-color: #4a90d9;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.qr-scanner-error .btn-retry:hover {\n  background-color: #3a7bc8;\n}\n\n.qr-scanner-error .btn-retry:active {\n  background-color: #2d6bb5;\n}\n\n/* 개발 환경 안내 */\n.qr-scanner-dev-notice {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  text-align: left;\n  padding: 8px 12px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.qr-scanner-dev-notice .dev-notice-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.qr-scanner-dev-notice p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.qr-scanner-dev-notice .dev-notice-sub {\n  margin-top: 2px;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* ── 카메라 없는 기기(안드로이드 TV·프로젝터 등) 대기 화면 ───────── */\n.qr-scanner-standby {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 100%;\n  height: 100%;\n  padding: 16px 12px;\n  text-align: center;\n  background: transparent;\n}\n\n.qr-scanner-standby-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #90A4AE;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
